export default __webpack_public_path__ + "static/media/03d55f3f8a58cf7f.ec82239b551d9498b9d7f656cc7d5747.svg";